import img1 from '../images/icon/hosting.png'
import img2 from '../images/icon/provision.png'
import img3 from '../images/icon/badge.png'
import img4 from '../images/icon/chat.png'

const dataCard = [
    {
        stt: '01',
        title:'Huge Collection',
        desc: 'Oficia dese runt mollit anim id est labo met, consectetur adipis',
        class: 'mr-28',

        class2: '',
        img: img1
    },
    {
        stt: '02',
        title:'High Quality',
        desc: 'Oficia dese runt mollit anim id est labo met, consectetur adipis',
        class: 'mt-45',

        class2: 's2',
        img: img2
    },
    {
        stt: '03',
        title:'Top Resource',
        desc: 'Oficia dese runt mollit anim id est labo met, consectetur adipis',
        class: 'mr-28 mt--16',

        class2: 's2-m',
        img: img3
    },
    {
        stt: '04',
        title:'Big Community',
        desc: 'Oficia dese runt mollit anim id est labo met, consectetur adipis',
        class: 'mt-29',

        class2: 's2',
        img: img4
    },
]

export default dataCard;